const SqueredPlusIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="2" fill="white" />
      <path d="M7.83276 16.0029H24.1709" stroke="#1062D0" strokeWidth="2" stroke-linecap="round" />
      <path d="M16.001 7.83301V24.1712" stroke="#1062D0" strokeWidth="2" stroke-linecap="round" />
    </svg>
  );
};

export default SqueredPlusIcon;
